// import React, { useState } from 'react';

// function JobTitleAutocomplete() {
//     const [term, setTerm] = useState('');
//     const [suggestions, setSuggestions] = useState([]);

//     const fetchSuggestions = (text) => {
//         const PDL_API_KEY = 'fff7deed4c98609eccb4a901db2b3a2a2d9273ac16d40bd58f3f7a504588548a'; // Replace with your actual API key
//         fetch(`https://api.peopledatalabs.com/v5/autocomplete?api_key=${PDL_API_KEY}&field=title&size=5&text=${text}`)
//             .then(res => res.json())
//             .then(data => {
//                 if (data.status === 200 && data.data) {
//                     setSuggestions(data.data); // Assuming data.data contains the suggestions
//                     console.log("suggestions are set");
//                 } else {
//                     console.error('Failed to load suggestions:', data.error);
//                 }
//             })
//             .catch(err => console.error('Fetch error:', err));
//     };

//     const handleTextChange = (e) => {
//         const text = e.target.value;
//         setTerm(text);
//         if (text.length > 2) {  // Fetch suggestions if the term is longer than 2 characters
//             fetchSuggestions(text);
//         } else {
//             setSuggestions([]);
//         }
//     };

//     return (
//         <div>
//             <input
//                 type="text"
//                 value={term}
//                 onChange={handleTextChange}
//                 placeholder="Start typing a job title..."
//             />
//             {suggestions.length > 0 && (
//                 <ul>
//                     {suggestions.map((item, index) => (
//                         <li key={index}>{item.name}</li> // Assuming the suggestion objects have a 'text' property
//                     ))}
//                 </ul>
//             )}
//         </div>
//     );
// }

// export default JobTitleAutocomplete;

import React, { useState, useEffect } from 'react';

function CurrencyConverter() {
    const [rates, setRates] = useState({});
    const [amount, setAmount] = useState('');
    const [currency, setCurrency] = useState('EUR');
    const [convertedAmount, setConvertedAmount] = useState('');

    useEffect(() => {
        fetch('http://api.finaloffers.fyi/api/rates')  // Adjust this URL to where your server is hosted
            .then(res => res.json())
            .then(data => {
                setRates(data);
            })
            .catch(err => console.error('Fetch error:', err));
    }, []);

    const handleAmountChange = (event) => {
        setAmount(event.target.value);
        const rate = rates[currency];
        setConvertedAmount(rate ? (event.target.value / rate).toFixed(2) : 'Invalid currency');
    };

    const handleCurrencyChange = (event) => {
        setCurrency(event.target.value);
        const rate = rates[event.target.value];
        setConvertedAmount(rate ? (amount / rate).toFixed(2) : 'Invalid currency');
    };

    return (
        <div>
            <h1>Currency Converter to USD</h1>
            
            <select value={currency} onChange={handleCurrencyChange}>
                {Object.keys(rates).map((key) => (
                    <option key={key} value={key}>{key}</option>
                ))}
            </select>
            <input type="number" value={amount} onChange={handleAmountChange} placeholder="Enter amount" />
            <p>Converted Amount in USD: {convertedAmount}</p>
        </div>
    );
}

export default CurrencyConverter;


// import React, { useState, useEffect, useRef } from 'react';

// function CityAutocomplete() {
//     const [input, setInput] = useState('');
//     const [suggestions, setSuggestions] = useState([]);
//     const autocompleteServiceRef = useRef(null);

//     useEffect(() => {
//         if (!window.google) {
//             const script = document.createElement('script');
//             script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDtxdG6etewvkpTp6W79Z9PLg-9QTDX85w&libraries=places`;
//             document.head.append(script);
//             script.onload = () => {
//                 initializeAutocomplete();
//             };
//             return () => script.remove();
//         } else {
//             initializeAutocomplete();
//         }
//     }, []);

//     const initializeAutocomplete = () => {
//         autocompleteServiceRef.current = new window.google.maps.places.AutocompleteService();
//     };

//     const handleInput = (e) => {
//         setInput(e.target.value);
//         if (e.target.value.length > 0) {
//             autocompleteServiceRef.current.getPlacePredictions({ input: e.target.value, types: ['(cities)'] }, (predictions, status) => {
//                 if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
//                     setSuggestions(predictions);
//                 } else {
//                     setSuggestions([]);
//                 }
//             });
//         } else {
//             setSuggestions([]);
//         }
//     };

//     return (
//         <div>
//             <input
//                 type="text"
//                 value={input}
//                 onChange={handleInput}
//                 placeholder="Enter a city"
//             />
//             {suggestions.length > 0 && (
//                 <ul>
//                     {suggestions.map((suggestion, index) => (
//                         <li key={index} onClick={() => setInput(suggestion.description)}>
//                             {suggestion.description}
//                         </li>
//                     ))}
//                 </ul>
//             )}
//         </div>
//     );
// }

// export default CityAutocomplete;

// import React from 'react';
// import AutoComplete from "react-google-autocomplete";

// function CityAutocomplete() {

//     return (
//         <div>
//             <AutoComplete
//                 apiKey='AIzaSyDtxdG6etewvkpTp6W79Z9PLg-9QTDX85w'
//                 onPlaceSelected={(place) => console.log(place)}
//             />
//         </div>
//     );
// }

// export default CityAutocomplete;

// import React, { useState } from 'react';

// function CompanyAutocomplete() {
//     const [input, setInput] = useState('');
//     const [suggestions, setSuggestions] = useState([]);

//     const apiKey = 'your_clearbit_api_key'; // Replace with your actual Clearbit API key

//     const handleInput = (event) => {
//         const value = event.target.value;
//         setInput(value);
//         if (!value) {
//             setSuggestions([]);
//         } else {
//             fetch(`https://autocomplete.clearbit.com/v1/companies/suggest?query=${value}`, {
//                 method: 'GET',
//                 headers: {
//                     'Authorization': `Bearer ${apiKey}`
//                 }
//             })
//             .then(response => response.json())
//             .then(data => {
//                 setSuggestions(data);
//             })
//             .catch(error => console.error('Error fetching data:', error));
//         }
//     };

//     const selectSuggestion = (name) => {
//         setInput(name);
//         setSuggestions([]);
//     };

//     return (
//         <div>
//             <h2>Company Search Autocomplete</h2>
//             <input
//                 type="text"
//                 value={input}
//                 onChange={handleInput}
//                 placeholder="Start typing..."
//             />
//             {suggestions.length > 0 && (
//                 <div style={{ position: 'absolute', border: '1px solid #d4d4d4', zIndex: 99 }}>
//                     {suggestions.map((item, index) => (
//                         <div
//                             key={index}
//                             style={{ padding: '10px', cursor: 'pointer', backgroundColor: '#fff' }}
//                             onClick={() => selectSuggestion(item.name)}
//                         >
//                             <div className='inline-flex w-full hover:rounded hover:bg-black hover:text-white'>
//                                 <img src={`https://logo.clearbit.com/${item.domain}`} alt={`${item.name} logo`} className="h-3 w-3 "/>
//                                 {item.name}{ item.domain}
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </div>
//     );
// }

// export default CompanyAutocomplete;
